// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactSegmentEntity from './entities/contact-segment.json';
import contactSegmentMenu from '../pages/contact-segment/menu.json';
import contactSegmentFullForm from '../pages/contact-segment/forms/full.json';
import contactSegmentContextForm from '../pages/contact-segment/forms/context.json';
import contactSegmentMiniForm from '../pages/contact-segment/forms/mini.json';
import contactSegmentLookupForm from '../pages/contact-segment/forms/lookup.json';
import contactSegmentTableView from '../pages/contact-segment/views/table.json';
import contactSegmentDashboardView from '../pages/contact-segment/views/dashboard.json';

/** Тип запису «Сегмент контакту» зі сторінками пакета: меню, форми та подання з pages/contact-segment/. */
export const contactSegmentDefinition: IRecordTypeDefinition = {
  ...contactSegmentEntity,
  views: assembleViewSet({
      table: contactSegmentTableView,
      dashboard: contactSegmentDashboardView,
  }),
  form: contactSegmentFullForm,
  forms: { full: contactSegmentFullForm, context: contactSegmentContextForm, mini: contactSegmentMiniForm, lookup: contactSegmentLookupForm },
  menu: contactSegmentMenu,
} as IRecordTypeDefinition;
